var map = {
	"./2@3x.png": "633f",
	"./404.png": "8f20",
	"./Android-market.png": "e91e",
	"./Android-qrCode.png": "c346",
	"./AndroidMarket.png": "d606",
	"./Apple-qrCode.png": "175d",
	"./Apple-store-2.png": "80d7",
	"./Apple-store.png": "9e5c",
	"./AppleStore.png": "8ceb",
	"./Google-play.png": "c98a",
	"./Google-qrCode.png": "477e",
	"./GooglePlay.png": "37a5",
	"./UEEx-logo.png": "085a",
	"./aboutus-8v/Defi_dis.png": "a29d",
	"./aboutus-8v/Defi_on.png": "4387",
	"./aboutus-8v/NFT_dis.png": "500f",
	"./aboutus-8v/NFT_on.png": "496f",
	"./aboutus-8v/about-top-banner.png": "59f5",
	"./aboutus-8v/adv_dis.png": "2c4d",
	"./aboutus-8v/adv_on.png": "2b3b",
	"./aboutus-8v/advantages.png": "361f",
	"./aboutus-8v/advantages1.png": "124d",
	"./aboutus-8v/advantages2.png": "f3a8",
	"./aboutus-8v/advantages3.png": "00a4",
	"./aboutus-8v/advantages4.png": "7662",
	"./aboutus-8v/advantages5.png": "fbcd",
	"./aboutus-8v/advantages6.png": "3d54",
	"./aboutus-8v/advantages_new.png": "aad4",
	"./aboutus-8v/banner.png": "2cad",
	"./aboutus-8v/banner_bg.png": "068d",
	"./aboutus-8v/ben.png": "c2ac",
	"./aboutus-8v/bottom-logo.png": "0cbb",
	"./aboutus-8v/bottom1-n.png": "f54d",
	"./aboutus-8v/bottom1.png": "2349",
	"./aboutus-8v/bottom2-n.png": "5c2b",
	"./aboutus-8v/bottom2.png": "e2e6",
	"./aboutus-8v/bottom3-n.png": "eb59",
	"./aboutus-8v/bottom3.png": "146c",
	"./aboutus-8v/bottom4.png": "a144",
	"./aboutus-8v/close-icon.png": "d8c2",
	"./aboutus-8v/contract/Ins.png": "0ef4",
	"./aboutus-8v/contract/di.png": "7351",
	"./aboutus-8v/contract/fb.png": "bc23",
	"./aboutus-8v/contract/me.png": "217f",
	"./aboutus-8v/contract/re.png": "72fa",
	"./aboutus-8v/contract/tg.png": "7b9b",
	"./aboutus-8v/contract/tw.png": "56af",
	"./aboutus-8v/contract/yt.png": "a9a0",
	"./aboutus-8v/crypto_dis.png": "9582",
	"./aboutus-8v/crypto_on.png": "7655",
	"./aboutus-8v/customer.png": "6ab9",
	"./aboutus-8v/ecosystem-bg.png": "96cc",
	"./aboutus-8v/game_dis.png": "56e0",
	"./aboutus-8v/game_on.png": "4456",
	"./aboutus-8v/link.png": "cc0d",
	"./aboutus-8v/logo-slogan-en.png": "9c42",
	"./aboutus-8v/logo-slogan.png": "5fd7",
	"./aboutus-8v/logo_aboutus.png": "c0d7",
	"./aboutus-8v/more_aboutus.png": "a555",
	"./aboutus-8v/nick.png": "0d78",
	"./aboutus-8v/ot1.png": "b3f2",
	"./aboutus-8v/ot2.png": "a1a8",
	"./aboutus-8v/ot3.png": "7bcb",
	"./aboutus-8v/ot4.png": "9f53",
	"./aboutus-8v/ot5.png": "7303",
	"./aboutus-8v/otf1.png": "eb97",
	"./aboutus-8v/otf2.png": "1973",
	"./aboutus-8v/otf3.png": "4f3f",
	"./aboutus-8v/otf4.png": "ea00",
	"./aboutus-8v/otf5.png": "61e1",
	"./aboutus-8v/roland.png": "7ca2",
	"./aboutus-8v/social_dis.png": "c829",
	"./aboutus-8v/social_on.png": "ef6b",
	"./aboutus-8v/user-centric.png": "fdc9",
	"./aboutus-8v/vision.png": "a821",
	"./aboutus-8v/vision_new.png": "7c99",
	"./add.png": "1d89",
	"./address.png": "c542",
	"./aed.png": "31c5",
	"./affiliate-program/banner.png": "089e",
	"./andriod.png": "0222",
	"./apk-day.png": "7b09",
	"./appDownLoad.png": "c735",
	"./apple.png": "4977",
	"./arrow-down.png": "4c22",
	"./arrow-down_clear.png": "b6fe",
	"./avatar.png": "690a",
	"./bannerImg.png": "b067",
	"./bijiu-logo.png": "d4a9",
	"./bijiu-logo2.png": "f59b",
	"./bijiu-no-data.png": "19b3",
	"./broker/bp-1.png": "c0b7e",
	"./broker/bp-2.png": "602a",
	"./broker/bp-3.png": "cae7",
	"./broker/bp-4.png": "742c",
	"./broker/canda.png": "4b28",
	"./broker/er-1-n.png": "7a88",
	"./broker/er-1.png": "a5e4",
	"./broker/er-2-n.png": "9e47",
	"./broker/er-2.png": "9093",
	"./broker/er-3-n.png": "b832",
	"./broker/er-3.png": "6a62",
	"./broker/er-4-n.png": "e97c",
	"./broker/er-4.png": "3ce7",
	"./broker/hands.png": "f42e",
	"./bv/aboutus.png": "3214",
	"./bv/arrow-down.png": "9bc1",
	"./bv/banner-b.png": "4c86",
	"./bv/banner-logo.png": "9ef0",
	"./bv/banner11.png": "0095",
	"./bv/banner12.png": "952f",
	"./bv/banner13.png": "e4b1",
	"./bv/bv-android-apk-new.png": "2178",
	"./bv/bv-android-apk.png": "0de0",
	"./bv/bv-app-store-new-stop-en.png": "f448",
	"./bv/bv-app-store-new-stop.png": "daea",
	"./bv/bv-app-store-new.png": "4c2f",
	"./bv/bv-app-store.png": "59a7",
	"./bv/bv-exchange.png": "5c04",
	"./bv/bv-success.png": "e0f5",
	"./bv/di.png": "8cb1",
	"./bv/down.png": "b78a",
	"./bv/faq1.png": "2567",
	"./bv/faq2.png": "aada",
	"./bv/faq3.png": "7583",
	"./bv/fb.png": "ffc2",
	"./bv/foot_logo.png": "a12b",
	"./bv/former-bg1-cn.png": "0005",
	"./bv/former-bg1.png": "6c28",
	"./bv/guide-close.png": "79a8",
	"./bv/guide/01_C_T.png": "5299",
	"./bv/guide/01_En.png": "9666",
	"./bv/guide/02_C_T.png": "afe7",
	"./bv/guide/02_En.png": "03bd",
	"./bv/guide/03_C_T.png": "97d5",
	"./bv/guide/03_En.png": "0ea7",
	"./bv/guide/04_C_T.png": "594a",
	"./bv/guide/04_En.png": "fc83",
	"./bv/guide/05_C_T.png": "a6d9",
	"./bv/guide/05_En.png": "1839",
	"./bv/guide/06_C_T.png": "a785",
	"./bv/guide/06_En.png": "4e16",
	"./bv/guide/1.png": "0559",
	"./bv/guide/2.png": "4392",
	"./bv/guide/3.png": "fa19",
	"./bv/guide/4.png": "821f",
	"./bv/guide/5.png": "dedc",
	"./bv/guide/6.png": "a437",
	"./bv/header-icon/andriod-kyc.png": "36f7",
	"./bv/header-icon/android-two-code.png": "84cf",
	"./bv/header-icon/apk-day-old.png": "a58b",
	"./bv/header-icon/apk-day.png": "07ea",
	"./bv/header-icon/apk.png": "2244",
	"./bv/header-icon/as-day.png": "5083",
	"./bv/header-icon/as.png": "a309",
	"./bv/header-icon/bbw.png": "d209",
	"./bv/header-icon/cj.png": "464c",
	"./bv/header-icon/df.png": "6724",
	"./bv/header-icon/gd.png": "167d",
	"./bv/header-icon/gp-day.png": "4e33",
	"./bv/header-icon/hd.png": "c365",
	"./bv/header-icon/ios-kyc.png": "5f5b",
	"./bv/header-icon/ios-two-code.png": "6681",
	"./bv/header-icon/lc.png": "4978",
	"./bv/header-icon/letter.png": "00f5",
	"./bv/header-icon/lts.png": "4df2",
	"./bv/header-icon/otc.png": "a025",
	"./bv/header-icon/ubw.png": "2f7e",
	"./bv/header-icon/xh.png": "7fde",
	"./bv/header-icon/ykj.png": "bd90",
	"./bv/hearder-menu-icon/menu-annou-on.png": "3173",
	"./bv/hearder-menu-icon/menu-annou.png": "b6d4",
	"./bv/hearder-menu-icon/menu-asset-on.png": "e8ff",
	"./bv/hearder-menu-icon/menu-asset.png": "88e9",
	"./bv/hearder-menu-icon/menu-chat-on.png": "668f",
	"./bv/hearder-menu-icon/menu-chat.png": "1d4b",
	"./bv/hearder-menu-icon/menu-coupon-on.png": "2247",
	"./bv/hearder-menu-icon/menu-coupon.png": "439d",
	"./bv/hearder-menu-icon/menu-earn-on.png": "2136",
	"./bv/hearder-menu-icon/menu-earn.png": "c7d1",
	"./bv/hearder-menu-icon/menu-help-on.png": "2a23",
	"./bv/hearder-menu-icon/menu-help.png": "de29",
	"./bv/hearder-menu-icon/menu-more.png": "d3b0",
	"./bv/hearder-menu-icon/menu-personal-on.png": "e73e",
	"./bv/hearder-menu-icon/menu-personal.png": "8f76",
	"./bv/hearder-menu-icon/menu-referrals-on.png": "a0c4",
	"./bv/hearder-menu-icon/menu-referrals.png": "50382",
	"./bv/hearder-menu-icon/menu-trade-on.png": "3d541",
	"./bv/hearder-menu-icon/menu-trade.png": "6f56",
	"./bv/hearder-menu-icon/menu-transaction-on.png": "8841",
	"./bv/hearder-menu-icon/menu-transaction.png": "5847",
	"./bv/in.png": "08ac",
	"./bv/join-us/di-on.png": "ce0b",
	"./bv/join-us/di.png": "8006",
	"./bv/join-us/fb-on.png": "ebfa",
	"./bv/join-us/fb.png": "1abc",
	"./bv/join-us/in-on.png": "77aa",
	"./bv/join-us/in.png": "346c",
	"./bv/join-us/me-on.png": "3e47",
	"./bv/join-us/me.png": "1a07",
	"./bv/join-us/re-on.png": "bced",
	"./bv/join-us/re.png": "e948",
	"./bv/join-us/tg-on.png": "d953",
	"./bv/join-us/tg.png": "14c2",
	"./bv/join-us/ti-on.png": "5d10",
	"./bv/join-us/ti.png": "c34e",
	"./bv/join-us/tt-on.png": "e85f",
	"./bv/join-us/tt.png": "a5f6",
	"./bv/join-us/yt-on.png": "7a21",
	"./bv/join-us/yt.png": "e381",
	"./bv/logo_8V.png": "46e9",
	"./bv/logo_8V_new.png": "20a9",
	"./bv/menu-icon/gr.png": "0939",
	"./bv/menu-icon/gr_on.png": "f6c3",
	"./bv/menu-icon/jy.png": "85dd",
	"./bv/menu-icon/jy_on.png": "0928",
	"./bv/menu-icon/kq.png": "bbc9",
	"./bv/menu-icon/kq_on.png": "32b8",
	"./bv/menu-icon/lc.png": "758f",
	"./bv/menu-icon/lc_on.png": "44dc",
	"./bv/menu-icon/tg.png": "4f46",
	"./bv/menu-icon/tg_on.png": "0ec4",
	"./bv/menu-icon/zc.png": "ae18",
	"./bv/menu-icon/zc_on.png": "5eec",
	"./bv/menu-icon/zd.png": "361c",
	"./bv/menu-icon/zd_on.png": "eb3e",
	"./bv/modify_user.png": "6267",
	"./bv/raise.png": "76d4",
	"./bv/security/google.png": "32bf",
	"./bv/security/mail.png": "a833",
	"./bv/security/password.png": "f180",
	"./bv/security/phone.png": "869b",
	"./bv/tg.png": "11e0",
	"./bv/ti.png": "93e7",
	"./bv/tips.png": "45f8",
	"./bv/tw.png": "e673",
	"./bv/warning.png": "0477",
	"./bv/yo.png": "4515",
	"./chat-wedget-white.png": "6580",
	"./chat-wedget.png": "4071",
	"./close.png": "04b3",
	"./contract-icon/cl.png": "e421",
	"./contract-icon/di.png": "5e60",
	"./contract-icon/em.png": "807a",
	"./contract-icon/fa.png": "7ef5",
	"./contract-icon/po.png": "7e8a",
	"./contract-icon/pop.png": "c1ac",
	"./contract-icon/re.png": "66d3",
	"./contract-icon/te.png": "3556",
	"./contract-icon/tw.png": "b4a6",
	"./contract-icon/wb.png": "780a",
	"./contract-icon/yo.png": "7e70",
	"./contract-icon/ze.png": "a45c",
	"./currency-switch.png": "fbf3",
	"./currency-value.png": "4c2b",
	"./dot.png": "d29c",
	"./en.png": "17b5",
	"./everTrust-logo.png": "272f",
	"./exchange/active.png": "3267",
	"./exchange/depth-1.png": "bdf2",
	"./exchange/depth-2.png": "54be",
	"./exchange/depth-3.png": "be06",
	"./exchange/noActive.png": "23ed",
	"./expression/expression-bad.png": "7f51",
	"./expression/expression-cool.png": "a7ea",
	"./expression/expression-great.png": "5dfa",
	"./fan.png": "0a6f",
	"./finances-bg-8coin.png": "51e2",
	"./finances-bg-8v.png": "9c1a",
	"./finances-bg-b9.png": "5c5c",
	"./finances-bg-maskex.png": "f519",
	"./finances-bg-ueex.png": "1abd",
	"./finances-bg.png": "4179",
	"./finances/current-img-1.png": "c120",
	"./finances/current-img-2.png": "43bd",
	"./finances/current-img-3.png": "c2cc",
	"./financial-detail/1@3x.png": "125a",
	"./financial-detail/2@3x.png": "c61e",
	"./financial-detail/3@3x.png": "c009",
	"./financial-detail/icon-2@3x.png": "7dfe",
	"./financial-detail/icon-3@3x.png": "0733",
	"./financial-detail/tro-bg.png": "7910",
	"./full-screen.png": "2162",
	"./gp-day.png": "04cd",
	"./holder-coin-ico.png": "896e",
	"./holder-coin-ico2.png": "5885",
	"./home/5-1.png": "c412",
	"./home/5-2.png": "ab05",
	"./home/5-3.png": "6b2c",
	"./home/app-down.png": "7b5e",
	"./home/banner-1.png": "7e8f",
	"./home/banner-2.png": "47ec",
	"./home/banner-3.png": "9fe9",
	"./home/banner-4.png": "2799",
	"./home/banner-5.png": "4256",
	"./home/bijiu-logo.png": "d5b8d",
	"./home/bijiu-no-data.png": "cd14",
	"./home/bitda/10-s.png": "16e7",
	"./home/bitda/banner-1.png": "a659",
	"./home/bitda/banner-2.png": "91bf",
	"./home/bitda/banner-3.png": "488d",
	"./home/bitda/banner-4.png": "c7b9",
	"./home/bitda/banner.png": "f2a4",
	"./home/bitda/bitda-tg-icon.png": "2b19",
	"./home/bitda/dlicon.png": "1869",
	"./home/bitda/fast-register-bg.png": "cc89",
	"./home/bitda/feature-01-zh.png": "f737",
	"./home/bitda/feature-01.png": "0a0d",
	"./home/bitda/feature-02-zh.png": "892a",
	"./home/bitda/feature-02.png": "f3aa",
	"./home/bitda/feature-03-zh.png": "2282",
	"./home/bitda/feature-03.png": "a388",
	"./home/bitda/feature-04-zh.png": "6978",
	"./home/bitda/feature-04.png": "2866",
	"./home/bitda/home-app-image-cn.png": "1353",
	"./home/bitda/home-app-image-en.png": "b7b7",
	"./home/bitda/home-app-image-hk.png": "71ec",
	"./home/bitda/home-app-image.png": "3a49",
	"./home/bitda/home-bg-01.png": "57c5",
	"./home/bitda/home-bg-02.png": "6683",
	"./home/bitda/home-bg-03.png": "3775",
	"./home/bitda/journey-01.png": "b248",
	"./home/bitda/journey-02.png": "f904",
	"./home/bitda/journey-03.png": "31b5",
	"./home/bitda/left-arrow.png": "4e77",
	"./home/bitda/right-arrow.png": "0187",
	"./home/down-btn-bitda.png": "a3e0",
	"./home/down-btn.png": "e05e",
	"./home/everTrust-logo-en.png": "c4fa",
	"./home/everTrust-logo-home.png": "fd22",
	"./home/google-down.png": "2dae",
	"./home/home-bg.png": "1e85",
	"./home/hx-mp4-bg.png": "fb24",
	"./home/index1.png": "8a66",
	"./home/index2.png": "febd",
	"./home/index3.png": "a24a",
	"./home/index4.png": "15bc",
	"./home/index5.png": "6405",
	"./home/index6.png": "3d69",
	"./home/index_middle-01@2x.png": "c171",
	"./home/index_middle-02@2x.png": "ee5f",
	"./home/index_middle-03@2x.png": "46fe",
	"./home/invite-en.png": "a2c7",
	"./home/invite.png": "d60f",
	"./home/left-arrow.png": "fe90",
	"./home/mask-no-data.png": "975b",
	"./home/no-data-100.png": "352b",
	"./home/no-data-5A.png": "c560",
	"./home/no-data-8coin.png": "3362",
	"./home/no-data-8v.png": "8104",
	"./home/no-data-Ahex.png": "5557",
	"./home/no-data-Ahex_predel.png": "b829",
	"./home/no-data-S6.png": "32cc",
	"./home/no-data-UEEx.png": "8dc1",
	"./home/no-data-bitda.png": "3490",
	"./home/no-data-easy.png": "22d5",
	"./home/no-data-spex.png": "be76",
	"./home/no_data.png": "0748",
	"./home/red-right.png": "0315",
	"./home/right-arrow.png": "6666",
	"./home/top-logo.png": "d676",
	"./home/trade-img-5a.png": "42bb",
	"./home/trade-img-8coin.png": "ba2b",
	"./home/trade-img-bjiu-zh.png": "2671",
	"./home/trade-img-bjiu.png": "0e42",
	"./home/trade-img-spex.png": "4927",
	"./home/trade-img-ueasy.png": "2694",
	"./home/trade-img.png": "ec70",
	"./home/trade-img2.png": "2625",
	"./home/trade-img3.png": "47bb",
	"./home/video-page.png": "b295",
	"./home/warning-icon-white.png": "9208",
	"./home/warning-icon.png": "7d0d",
	"./home/web-banner.png": "6a56",
	"./huixintg.png": "594a6",
	"./ja.png": "4c15",
	"./ko.png": "2b91",
	"./lang/f-ar.png": "cc64",
	"./lang/f-cn.png": "232d",
	"./lang/f-de.png": "e207",
	"./lang/f-en.png": "4519",
	"./lang/f-es.png": "7c36",
	"./lang/f-fr.png": "dc10",
	"./lang/f-hi.png": "da37",
	"./lang/f-hk.png": "3625",
	"./lang/f-id.png": "6bbc",
	"./lang/f-it.png": "79c2",
	"./lang/f-ja.png": "93e5",
	"./lang/f-ko.png": "77f6",
	"./lang/f-pt.png": "16e9",
	"./lang/f-ru.png": "376b",
	"./lang/f-th.png": "7a2d",
	"./lang/f-tl.png": "6afb",
	"./lang/f-tr.png": "ffee",
	"./lang/f-vi.png": "d1c0",
	"./lang/f-zh_CN.png": "a199",
	"./lang/f-zh_HK.png": "a6e5",
	"./left-a.png": "aa26",
	"./left-arrow-bv.png": "7d63",
	"./left-arrow.png": "abff",
	"./letter-header.png": "ddaa",
	"./letter.png": "15e2",
	"./login-app.png": "d4fb",
	"./login/banner.png": "6a3e",
	"./login/close_eye.png": "d538",
	"./login/eye-off.png": "2c99",
	"./login/eye-open.png": "b127",
	"./login/open_eye.png": "a6af",
	"./login_bg.png": "bfbd",
	"./logo-hk.png": "455c",
	"./logo-zh.png": "6723",
	"./logo.png": "4ffd",
	"./logo2.png": "440d",
	"./logo3.png": "7cbd",
	"./logo4.png": "3595",
	"./logo_100.png": "248a",
	"./logo_5A.png": "aecc",
	"./logo_5A_zh_CN.png": "abcc",
	"./logo_8V.png": "9468",
	"./logo_8coin.png": "df32",
	"./logo_Ahex.png": "58b7",
	"./logo_Ahex_predel.png": "c96e",
	"./logo_S6.png": "4847",
	"./logo_UEEx.png": "d50b",
	"./logo_Ueasy.png": "5aa4",
	"./logo_bitda.png": "8c5b",
	"./logo_bitda_footer.png": "c6fb",
	"./logo_bitda_header.png": "32e8",
	"./logo_doge.png": "9b4d",
	"./logo_easy.png": "cadf",
	"./logo_spex.png": "ab9a",
	"./markets/markets-top-bg.png": "71bc",
	"./markets/markt-download-8c.png": "f8de",
	"./markets/markt-download.png": "63a6",
	"./markets/markt-up-8c.png": "580b",
	"./markets/markt-up.png": "cfa4",
	"./markets/下载 (2).png": "a4bc",
	"./markets/下载 (3).png": "2a61",
	"./markets/下载 (5).png": "9971",
	"./markets/下载.png": "b3ee",
	"./mask-logo.png": "6b4f",
	"./mask/BTC-icon.png": "6372",
	"./mask/Eth-icon.png": "02ec",
	"./mask/blog/blog-banner.png": "2bc5",
	"./mask/blog/discord.png": "3d7b",
	"./mask/blog/facebook.png": "5111",
	"./mask/blog/instagram.png": "d4e4",
	"./mask/blog/left-btn.png": "b732",
	"./mask/blog/linkedin.png": "e1f7",
	"./mask/blog/right-btn.png": "93dd",
	"./mask/blog/telegram.png": "d530",
	"./mask/blog/tiktok.png": "003f",
	"./mask/blog/twitter.png": "e6ff",
	"./mask/blog/youtube.png": "8df6",
	"./mask/chat-icon.png": "f141",
	"./mask/delete.png": "2ddf",
	"./mask/edit.png": "0631",
	"./mask/five-1.png": "da08",
	"./mask/five-2.png": "ee95",
	"./mask/five-3.png": "b090",
	"./mask/five-4.png": "7158",
	"./mask/five-5.png": "cb5b",
	"./mask/footer/discord.png": "d132",
	"./mask/footer/facebook.png": "686d",
	"./mask/footer/instagram.png": "a2e2",
	"./mask/footer/linkedin.png": "dcdb",
	"./mask/footer/telegram.png": "7622",
	"./mask/footer/tiktok.png": "4660",
	"./mask/footer/twitter.png": "0834",
	"./mask/footer/youtube.png": "7cb8",
	"./mask/home-bg.png": "9479",
	"./mask/home-bg2.png": "b2e2",
	"./mask/home-icon-1.png": "a6de",
	"./mask/home-icon-2.png": "1675",
	"./mask/home-icon-3.png": "7b9c",
	"./mask/home-icon-4.png": "c03a",
	"./mask/home-icon-5.png": "e1f7d",
	"./mask/home-icon-6.png": "8b30",
	"./mask/home-icon-7.png": "4c8d",
	"./mask/mask-app-store.png": "1d1b",
	"./mask/mask-exchange.png": "7d42",
	"./mask/mask-google-play.png": "2882",
	"./mask/mask-home-banner-en.png": "1279",
	"./mask/mask-home-banner-ja.png": "b614",
	"./mask/mask-home-banner-ko.png": "d5cf",
	"./mask/mask-home-banner-zh_HK.png": "86c3",
	"./mask/maskex-down-btn.png": "3326",
	"./mask/maskexbanner.png": "6283",
	"./mask/maskexicon1.png": "0996",
	"./mask/maskexicon2.png": "1834",
	"./mask/maskexicon3.png": "ae79",
	"./mask/maskexicon4.png": "6a5d0",
	"./mask/top-icon.png": "a5d8",
	"./mask/usdt-icon.png": "5157",
	"./mask/video1.png": "ac64",
	"./mask/video2.png": "8b7b",
	"./mask/video3.png": "9293",
	"./maskEx/bannerImg.png": "5a4b",
	"./maskEx/groupMap.png": "acfb",
	"./maskEx/img1.png": "5415",
	"./maskEx/img2.png": "0ec8",
	"./maskEx/img3.png": "e582",
	"./maskEx/img4.png": "2d834",
	"./maskEx/mask-group.png": "9267",
	"./maskEx/ourTeam/1.png": "c919",
	"./maskEx/ourTeam/10.png": "ed7e",
	"./maskEx/ourTeam/11.png": "e21e2",
	"./maskEx/ourTeam/12.png": "c0d8",
	"./maskEx/ourTeam/13.png": "714d",
	"./maskEx/ourTeam/14.png": "2867",
	"./maskEx/ourTeam/15.png": "0063",
	"./maskEx/ourTeam/16.png": "69d6",
	"./maskEx/ourTeam/17.png": "e0ea",
	"./maskEx/ourTeam/18.png": "e507d",
	"./maskEx/ourTeam/19.png": "5e0b",
	"./maskEx/ourTeam/2.png": "a556",
	"./maskEx/ourTeam/20.png": "34fa",
	"./maskEx/ourTeam/21.png": "9440",
	"./maskEx/ourTeam/22.png": "319e",
	"./maskEx/ourTeam/23.png": "2ce2",
	"./maskEx/ourTeam/24.png": "ff02",
	"./maskEx/ourTeam/25.png": "b7c8",
	"./maskEx/ourTeam/26.png": "662a",
	"./maskEx/ourTeam/27.png": "7cc6",
	"./maskEx/ourTeam/3.png": "c602",
	"./maskEx/ourTeam/4.png": "dc44",
	"./maskEx/ourTeam/5.png": "3487",
	"./maskEx/ourTeam/6.png": "ecd4",
	"./maskEx/ourTeam/7.png": "39a8",
	"./maskEx/ourTeam/8.png": "f5cf",
	"./maskEx/ourTeam/9.png": "e98b",
	"./maskEx/ourTeamEx/1.png": "a87a",
	"./maskEx/ourTeamEx/10.png": "d834",
	"./maskEx/ourTeamEx/11.png": "1c63",
	"./maskEx/ourTeamEx/12.png": "f3e6",
	"./maskEx/ourTeamEx/13.png": "cc07",
	"./maskEx/ourTeamEx/2.png": "8fa0",
	"./maskEx/ourTeamEx/3.png": "41b4",
	"./maskEx/ourTeamEx/4.png": "6ff9",
	"./maskEx/ourTeamEx/5.png": "6052",
	"./maskEx/ourTeamEx/6.png": "237d",
	"./maskEx/ourTeamEx/7.png": "816d",
	"./maskEx/ourTeamEx/8.png": "eefa",
	"./maskEx/ourTeamEx/9.png": "66f9",
	"./maskEx/register-gift.png": "3f89",
	"./maskEx/teamImg.png": "693f",
	"./maskexcard/14b4e47aad4988246ed05ecd1c9b22c7.png": "154a",
	"./maskexcard/2d884caa633c469ca3256071ebbd674f.png": "aea5",
	"./maskexcard/2f53846efeacc1ec0255dfa2bc5b2446.png": "52f8",
	"./maskexcard/34491fee89cbdecd3670436100144af4.png": "b2fa",
	"./maskexcard/408ff219b420be869f5c045bf3aa4438.png": "fc82",
	"./maskexcard/471ef7cbe3a373d87c8f96500ddf1cb1.png": "6295",
	"./maskexcard/986e4dd04f282c78248a3974a3e039d8.png": "14e5",
	"./maskexcard/a277e2e773b04321380845a86503eb75.png": "7a07",
	"./maskexcard/c10bec8ecf730f0d58c7fc4a94dd2116.png": "6640",
	"./maskexcard/e0bef3dd18ad091ac85413f98a0eec1c.png": "c1eb",
	"./maskexcard/ed60f85b7c9b18beb3d54558d7bcdf25.png": "bb73",
	"./mbk.png": "9e82",
	"./mht.png": "a6f6",
	"./mining-pool-bg.png": "3afa",
	"./no_data.png": "32a2",
	"./notice/notice-bg.png": "f06d",
	"./photo-camera.png": "f110",
	"./placeholder.png": "59e0",
	"./profit_loss_share_bg.png": "de6a",
	"./qr_code.png": "840a",
	"./quickly-coins/AlchemyPay.png": "e012",
	"./quickly-coins/Moonpay.png": "e1a6",
	"./quickly-coins/Paxful.png": "0fd4",
	"./quickly-coins/Routelay.png": "ffe9",
	"./quickly-coins/Simplex.png": "aeb4",
	"./quickly-coins/Transak.png": "b7bb",
	"./quickly-coins/banxa.png": "adb8",
	"./quickly-coins/ipay.png": "1573",
	"./quickly-coins/itez.png": "3e5a",
	"./quickly-coins/m-choose-a.png": "fd3b",
	"./quickly-coins/m-choose.png": "e459",
	"./quickly-coins/mastercard.png": "cad3",
	"./quickly-coins/mercuryo_n.png": "ef2a",
	"./quickly-coins/quicklycoins-bg.png": "c8a3",
	"./quickly-coins/scpa.png": "4082",
	"./quickly-coins/visa.png": "d4eb",
	"./quickly-coins/wyre.png": "203c",
	"./rePhoto/1.png": "dea4",
	"./rePhoto/2.png": "e4ff",
	"./right-a.png": "617e",
	"./right-arrow-bv.png": "fbe4",
	"./right-arrow.png": "0fe1",
	"./select-icon.png": "62ef",
	"./shareInvite/ci.png": "ed9d",
	"./shareInvite/cl.png": "0ea2",
	"./shareInvite/fb.png": "f002",
	"./shareInvite/si.png": "416e",
	"./shareInvite/tg.png": "91e7",
	"./shareInvite/tt.png": "1630",
	"./shareInvite/wx.png": "7ded",
	"./shili1.png": "bfb8",
	"./siteLogo/8coin.png": "6956",
	"./siteLogo/8v.png": "69a6",
	"./siteLogo/Ahex.png": "2611",
	"./siteLogo/Ahex_predel.png": "58a7",
	"./siteLogo/b9.png": "a481",
	"./siteLogo/b9_text.png": "095f",
	"./siteLogo/bxc.png": "2d5f",
	"./siteLogo/everTrust.png": "5c53",
	"./siteLogo/hx.png": "74be",
	"./siteLogo/hx_b.png": "e44f",
	"./siteLogo/hxlogo_text.png": "387d",
	"./siteLogo/logo100.png": "8b1d",
	"./siteLogo/logo100_text.png": "3533",
	"./siteLogo/logo5A.png": "8812",
	"./siteLogo/logoEasy.png": "76f2",
	"./siteLogo/logoS6.png": "9ff7",
	"./siteLogo/logobitda.png": "08fb",
	"./siteLogo/mask.png": "1438",
	"./siteLogo/mask_new.png": "5e3b",
	"./siteLogo/mask_text.png": "aa97",
	"./siteLogo/spex.png": "c04d",
	"./siteLogo/ueasy.png": "4b7f",
	"./sprz.png": "e40c",
	"./st-icon-1-1.png": "b435",
	"./st-icon-1.png": "23c4",
	"./st-icon-2-1.png": "245c",
	"./st-icon-2.png": "363a",
	"./st-icon-3-1.png": "5fe5",
	"./st-icon-3.png": "decf",
	"./stock_hk.png": "3b59",
	"./stock_us.png": "4952",
	"./success.png": "d284",
	"./table-empty@2x.png": "fa35",
	"./tg.png": "61ce",
	"./tran-to.png": "2eb6",
	"./ueasy-logo.png": "72ab",
	"./ueex/about-us/logo-text.png": "d803",
	"./ueex/about-us/milestones-line.png": "ea65",
	"./ueex/about-us/security1.png": "d194",
	"./ueex/about-us/security2.png": "6788",
	"./ueex/about-us/team1.png": "e545",
	"./ueex/about-us/team2.png": "6105",
	"./ueex/about-us/team3.png": "077a",
	"./ueex/about-us/team4.png": "25a4",
	"./ueex/bg-1.png": "3050",
	"./ueex/bg-2.png": "e258",
	"./ueex/bg-3.png": "1997",
	"./ueex/bg-4.png": "75a6",
	"./ueex/facebook.png": "72b8",
	"./ueex/instagram.png": "a6aa",
	"./ueex/linkedin.png": "765e",
	"./ueex/mask-google-play.png": "2d52",
	"./ueex/point-1.png": "a1b3",
	"./ueex/point-2.png": "bc5e",
	"./ueex/point-3.png": "fb8e",
	"./ueex/telegram.png": "f858",
	"./ueex/twitter.png": "1bc3",
	"./ueex/ueex-app-store.png": "040e",
	"./ueex/ueex-down-btn.png": "bcc9",
	"./ueex/ueex-google-play.png": "fecc",
	"./ueex/ueexbanner.png": "8265",
	"./ueex/ueexbanner1.png": "7239",
	"./ueex/vote-for-listing/one.png": "e9b8",
	"./ueex/youtube.png": "7fa0",
	"./uld.png": "dbf5",
	"./user-icon.png": "3591",
	"./vip-level/vip-0.png": "edd8",
	"./vip-level/vip-1.png": "88e1",
	"./vip-level/vip-2.png": "a935",
	"./zh_CN.png": "e0c3",
	"./zh_HK.png": "216f",
	"./zoom-screen.png": "5e4b",
	"./zqsl.png": "a89d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";